<template>
  <v-app>
    <div>
      <v-hover v-slot="{ hover }">
        <v-app-bar app dense style="background: #110000CC; " :elevation="hover ? 8 : 2">          
          <img class="ml-0" src="./assets/logo_wide_white.png" style="height:25px;" />  
          <v-spacer></v-spacer>
          <div v-show="wide_windows" style="float:right;">
            <v-row>
              <div class="mr-10 mt-1">
                <v-btn small text dark><v-icon>mdi-earth</v-icon></v-btn>
                <v-btn-toggle v-model="toggle" dark mandatory>
                  <v-btn small @click="goKorPage()">
                    ko
                  </v-btn>
                  <v-btn small @click="goEnPage()">
                    en
                  </v-btn>
                </v-btn-toggle>
              </div>

              <div class="hidden-sm-and-down">
                <v-btn text @click="$vuetify.goTo('#scoll_About', null)"><span class="mr-1 white--text">About</span> </v-btn>
                <v-btn text @click="$vuetify.goTo('#scoll_Solution', null)"> <span class="mr-1 white--text">Solution</span> </v-btn>                
                <v-btn text @click="$vuetify.goTo('#scoll_Service', null)"> <span class="mr-1 white--text">Service</span> </v-btn>        
                <v-btn text @click="$vuetify.goTo('#scoll_History', null)"> <span class="mr-1 white--text">History</span> </v-btn>        
                <v-btn text @click="$vuetify.goTo('#scoll_Contact', null)"> <span class="mr-1 white--text">Contact</span> </v-btn>   
              </div>
            </v-row>
          </div>

          <div v-show="!wide_windows" style="float:right;">
            <v-row>
              <div class="mt-1">
                <v-btn small text dark><v-icon>mdi-earth</v-icon></v-btn>
                <v-btn-toggle v-model="toggle" dark mandatory>
                  <v-btn small @click="goKorPage()">
                    ko
                  </v-btn>
                  <v-btn small @click="goEnPage()">
                    en
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-row>
          </div>


        </v-app-bar>   
      </v-hover>
    </div>
    
    
    <div>
      <v-row v-resize="onResize">      
      </v-row>
    </div>

    <div class="main_image">      
      <!-- <img src="./assets/main_image.png" align="center" width="100%"> -->      
        <v-img id="blinking"  src="./assets/background.png" :aspect-ratio="ratio" height="500px"/>       
        <!-- <v-img id="blinking"  src="./assets/background.jpg" :aspect-ratio="ratio" height="500px"/>        -->
    </div>

    <CoreView />


    <!-- <v-main>
      <Content/>
    </v-main> -->

  
    <!-- <Conditions/> -->
    <PrivacyPolicy/>
    
  </v-app>
</template>

<script>
// import Content from './components/Content';
import PrivacyPolicy from './components/Conditions.vue';

import CoreView from "@/components/core/View.vue";
// import { defualtMeta } from '@/utils/meta';

import router from "@/router/index"

export default {
  name: 'App',
  components: {
    // Content,
    PrivacyPolicy,
    CoreView,
  },

  mounted () {
      this.onResize()
  },
  data: () => ({
    dialog : false,
    dialog2 : false,
    windowSize: {
        x: 0,
        y: 0,
      },
    wide_windows : true,
    ratio : 1,
    toggle: null,
    switch1: true,
  }),

  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.ratio = window.innerWidth / window.innerHeight * 1.2;
      this.wide_windows = (window.innerWidth >= 640);
    },

    goKorPage(){
      router.push({ name: "ko" });
      this.toggle = 0;
    },
    goEnPage(){
      router.push({ name: "en" });
      this.toggle = 1;
    },

  },

};
</script>


<style scoped>
  .main_header {   
  z-index: 100;
  padding: 7px;
  display:inline-block;
  position: fixed;  
  left: 0;
  top: 0;
  width:100%;
  height:50px;
  background: #110000CC;   
  }
  
  .main_header2 {   
  background: #110000CC;   
  } 

  .main_image { 
  position: absolute;    
  left: 0px;
  top: 0px;  
  width: 100%;  
  height:500px;
  background: #000000;
  }
  

  .class_btn{
		height: 30px;
		width: 30px;
		font-size: 15px;
		/* margin: 5px; */
		display: flex;
    justify-content: center;
    align-items: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none
	}

#blinking{
	-webkit-animation:blink 10s ease-in-out infinite alternate;
    -moz-animation:blink 10s ease-in-out infinite alternate;
    animation:blink 10s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.1;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.1;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.1;}
    100% {opacity:1;}
} 


</style>


